(() => {
  const slugify = (value) =>
    value
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "");

  const initLegalPage = (root) => {
    const content = root.querySelector("[data-legal-content]");
    const toc = root.querySelector("[data-legal-toc]");
    if (!content || !toc) return;

    const list = toc.querySelector("ol");
    const headings = Array.from(content.querySelectorAll("h2"));
    if (!list || headings.length < 2) {
      toc.classList.add("is-empty");
      return;
    }

    headings.forEach((heading, index) => {
      if (!heading.id) {
        heading.id = slugify(heading.textContent || `section-${index + 1}`) || `section-${index + 1}`;
      }

      const item = document.createElement("li");
      const link = document.createElement("a");
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      item.appendChild(link);
      list.appendChild(item);
    });
  };

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-legal-bouquet]").forEach(initLegalPage);
  });
})();
